/**
 * Mock dashboard data — remove when dashboard APIs are available.
 * Used by src/services/dashboard.ts when useDashboardMock() is true.
 */
import type {
  DashboardAuditLogEntry,
  DashboardCaseRow,
  DashboardChartResponse,
  DashboardSummaryResponse,
  DashboardVariant,
} from '../types/dashboard';

export const MOCK_DASHBOARD_CASES: DashboardCaseRow[] = [
  {
    caseRequestId: 'cr-0892',
    fileRef: 'SG-2024-0892',
    fileCategory: 'Criminal Division – Litigation',
    subFileCategory: 'Offence Affecting Human Body/Life',
    submittedAgency: 'Criminal Division',
    submittedAt: '2026-06-12T09:14:00',
    workflowStage: 'Drafting',
    allocationOfficer: 'K. Silva (DSG)',
    assignedOfficer: 'A. Perera',
    supervisor: 'K. Silva',
    stateAttorney: 'N. Perera',
    taskStatus: 'Pending Assignment',
    urgencyLevel: 'High',
  },
  {
    caseRequestId: 'cr-0891',
    fileRef: 'SG-2024-0891',
    fileCategory: 'Civil Division – Advise',
    subFileCategory: 'C – Action Instituted by State',
    submittedAgency: 'Civil Division',
    submittedAt: '2026-06-11T14:32:00',
    workflowStage: 'Pending Review',
    allocationOfficer: 'K. Silva (DSG)',
    assignedOfficer: 'K. Silva',
    supervisor: 'R. Fernando',
    stateAttorney: 'M. Jayawardena',
    taskStatus: 'Forwarded',
    urgencyLevel: 'Medium',
  },
  {
    caseRequestId: 'cr-0890',
    fileRef: 'SG-2024-0890',
    fileCategory: 'Civil Division – Litigation',
    subFileCategory: 'L – Land Acquisition',
    submittedAgency: 'Supreme Court Registry',
    submittedAt: '2026-06-10T10:05:00',
    workflowStage: 'Filed in Court',
    allocationOfficer: 'R. Fernando',
    assignedOfficer: 'R. Fernando',
    supervisor: 'K. Silva',
    stateAttorney: 'S. Wickramasinghe',
    taskStatus: 'Completed',
    urgencyLevel: 'High',
  },
  {
    caseRequestId: 'cr-0889',
    fileRef: 'SG-2024-0889',
    fileCategory: 'Civil Division – Advise',
    subFileCategory: 'CA – Actions Against State',
    submittedAgency: 'Civil Division',
    submittedAt: '2026-06-10T08:47:00',
    workflowStage: 'Pending Assignment',
    allocationOfficer: '—',
    assignedOfficer: '—',
    supervisor: '—',
    stateAttorney: '—',
    taskStatus: 'Pending Assignment',
    urgencyLevel: 'Low',
  },
  {
    caseRequestId: 'cr-0888',
    fileRef: 'SG-2024-0888',
    fileCategory: 'Criminal Division – Advice',
    subFileCategory: 'CH – Child Abuse',
    submittedAgency: 'Criminal Division',
    submittedAt: '2026-06-09T11:20:00',
    workflowStage: 'Completed',
    allocationOfficer: 'S. Ranasinghe',
    assignedOfficer: 'S. Ranasinghe',
    supervisor: 'K. Silva',
    stateAttorney: 'D. Bandara',
    taskStatus: 'Completed',
    urgencyLevel: 'High',
  },
  {
    caseRequestId: 'cr-0887',
    fileRef: 'SG-2024-0887',
    fileCategory: 'Civil Litigation – Appellate Courts',
    subFileCategory: 'C – Civil Appeal',
    submittedAgency: 'Court of Appeal',
    submittedAt: '2026-06-08T15:55:00',
    workflowStage: 'Under Review',
    allocationOfficer: 'A. Perera',
    assignedOfficer: 'A. Perera',
    supervisor: 'R. Fernando',
    stateAttorney: 'N. Perera',
    taskStatus: 'Reverted',
    urgencyLevel: 'High',
  },
  {
    caseRequestId: 'cr-0886',
    fileRef: 'SG-2024-0886',
    fileCategory: 'Extradition & Mutual Legal Assistance',
    subFileCategory: 'MLA – Treaty Request',
    submittedAgency: 'Ministry of Justice',
    submittedAt: '2026-06-07T09:30:00',
    workflowStage: 'Drafting',
    allocationOfficer: 'N. Jayasuriya',
    assignedOfficer: 'N. Jayasuriya',
    supervisor: 'K. Silva',
    stateAttorney: 'M. Jayawardena',
    taskStatus: 'Forwarded',
    urgencyLevel: 'Medium',
  },
  {
    caseRequestId: 'cr-0885',
    fileRef: 'SG-2024-0885',
    fileCategory: 'Criminal Litigation – Appellate Courts',
    subFileCategory: 'Offence Against Property',
    submittedAgency: 'Criminal Division',
    submittedAt: '2026-06-06T13:18:00',
    workflowStage: 'Pending Review',
    allocationOfficer: 'A. Perera',
    assignedOfficer: 'A. Perera',
    supervisor: 'R. Fernando',
    stateAttorney: 'S. Wickramasinghe',
    taskStatus: 'Escalated',
    urgencyLevel: 'High',
  },
  {
    caseRequestId: 'cr-0884',
    fileRef: 'SG-2024-0884',
    fileCategory: 'Right to Information',
    subFileCategory: 'RTI – State Entity',
    submittedAgency: 'RTI Commission',
    submittedAt: '2026-06-05T10:44:00',
    workflowStage: 'Assigned',
    allocationOfficer: 'S. Ranasinghe',
    assignedOfficer: 'S. Ranasinghe',
    supervisor: 'K. Silva',
    stateAttorney: 'D. Bandara',
    taskStatus: 'Pending Assignment',
    urgencyLevel: 'Low',
  },
  {
    caseRequestId: 'cr-0883',
    fileRef: 'SG-2024-0883',
    fileCategory: 'Public Petitions',
    subFileCategory: 'PP – Fundamental Rights',
    submittedAgency: 'Supreme Court',
    submittedAt: '2026-06-04T16:02:00',
    workflowStage: 'Under Review',
    allocationOfficer: 'K. Silva (DSG)',
    assignedOfficer: 'K. Silva',
    supervisor: '—',
    stateAttorney: '—',
    taskStatus: 'Reverted',
    urgencyLevel: 'Medium',
  },
  {
    caseRequestId: 'cr-0882',
    fileRef: 'SG-2024-0882',
    fileCategory: 'Civil Division – Litigation',
    subFileCategory: 'CA – Actions Against State',
    submittedAgency: 'High Court',
    submittedAt: '2026-06-03T08:15:00',
    workflowStage: 'Filed in Court',
    allocationOfficer: 'R. Fernando',
    assignedOfficer: 'R. Fernando',
    supervisor: 'K. Silva',
    stateAttorney: 'N. Perera',
    taskStatus: 'Completed',
    urgencyLevel: 'Low',
  },
  {
    caseRequestId: 'cr-0881',
    fileRef: 'SG-2024-0881',
    fileCategory: 'Attorney General',
    subFileCategory: 'AG – Advisory Opinion',
    submittedAgency: 'Cabinet Secretariat',
    submittedAt: '2026-06-02T11:37:00',
    workflowStage: 'Drafting',
    allocationOfficer: 'N. Jayasuriya',
    assignedOfficer: 'N. Jayasuriya',
    supervisor: 'K. Silva',
    stateAttorney: 'M. Jayawardena',
    taskStatus: 'Forwarded',
    urgencyLevel: 'Medium',
  },
  {
    caseRequestId: 'cr-0880',
    fileRef: 'SG-2024-0880',
    fileCategory: 'Criminal Division – Advice',
    subFileCategory: 'Offence Affecting Human Body/Life',
    submittedAgency: 'Police Commission',
    submittedAt: '2026-06-01T09:50:00',
    workflowStage: 'Completed',
    allocationOfficer: 'A. Perera',
    assignedOfficer: 'A. Perera',
    supervisor: 'R. Fernando',
    stateAttorney: 'S. Wickramasinghe',
    taskStatus: 'Completed',
    urgencyLevel: 'Low',
  },
  {
    caseRequestId: 'cr-0879',
    fileRef: 'SG-2024-0879',
    fileCategory: 'Civil Division – Advise',
    subFileCategory: 'L – Land Dispute',
    submittedAgency: 'Land Commissioner',
    submittedAt: '2026-05-31T14:22:00',
    workflowStage: 'Pending Assignment',
    allocationOfficer: '—',
    assignedOfficer: '—',
    supervisor: '—',
    stateAttorney: '—',
    taskStatus: 'Pending Assignment',
    urgencyLevel: 'Medium',
  },
  {
    caseRequestId: 'cr-0878',
    fileRef: 'SG-2024-0878',
    fileCategory: 'AGD – Internal',
    subFileCategory: 'Internal – Admin',
    submittedAgency: 'AGD',
    submittedAt: '2026-05-30T10:08:00',
    workflowStage: 'Completed',
    allocationOfficer: 'S. Ranasinghe',
    assignedOfficer: 'S. Ranasinghe',
    supervisor: 'K. Silva',
    stateAttorney: 'D. Bandara',
    taskStatus: 'Completed',
    urgencyLevel: 'Low',
  },
];

const URGENCY_COLORS = ['#dc2626', '#f59e0b', '#16a34a', '#94a3b8'];
const SG_STATUS_COLORS = ['#f59e0b', '#dc2626', '#f97316', '#3b82f6', '#16a34a'];
const OP_STATUS_COLORS = ['#dc2626', '#f97316', '#3b82f6', '#16a34a'];
const CATEGORY_COLORS = [
  '#3b82f6',
  '#8b5cf6',
  '#ec4899',
  '#14b8a6',
  '#f97316',
  '#a3e635',
  '#fb923c',
  '#94a3b8',
  '#06b6d4',
  '#f43f5e',
  '#64748b',
  '#6366f1',
];

export const MOCK_SG_SUMMARY: DashboardSummaryResponse = {
  kpis: [
    { key: 'submitted', value: 1248, color: 'blue', tooltip: '' },
    { key: 'pendingAssignment', value: 42, color: 'amber', tooltip: '' },
    { key: 'assignedInProgress', value: 1106, color: 'green', tooltip: '' },
    { key: 'highUrgency', value: 18, color: 'red', tooltip: '' },
    { key: 'escalated', value: 7, color: 'orange', tooltip: '' },
    { key: 'kpiCompliant', value: 1089, color: 'teal', tooltip: '' },
    { key: 'completed', value: 312, color: 'purple', tooltip: '' },
  ],
};

export const MOCK_OPERATIONAL_SUMMARY: DashboardSummaryResponse = {
  kpis: [
    { key: 'assignedInProgress', value: 1106, color: 'green', tooltip: '' },
    { key: 'highUrgency', value: 18, color: 'red', tooltip: '' },
    { key: 'escalated', value: 7, color: 'orange', tooltip: '' },
    { key: 'kpiCompliant', value: 1089, color: 'teal', tooltip: '' },
    { key: 'completed', value: 312, color: 'purple', tooltip: '' },
  ],
};

export const MOCK_URGENCY_CHART: DashboardChartResponse = {
  slices: [
    {
      label: 'High',
      value: 18,
      color: URGENCY_COLORS[0],
      breakdown: ['Criminal Division: 55% (10)', 'Civil Division: 45% (8)'],
    },
    {
      label: 'Medium',
      value: 342,
      color: URGENCY_COLORS[1],
      breakdown: ['Criminal Division: 60% (205)', 'Civil Division: 40% (137)'],
    },
    {
      label: 'Low',
      value: 888,
      color: URGENCY_COLORS[2],
      breakdown: ['Criminal Division: 50% (444)', 'Civil Division: 50% (444)'],
    },
  ],
};

export const MOCK_SG_STATUS_CHART: DashboardChartResponse = {
  slices: [
    {
      label: 'Pending Assignment',
      value: 42,
      color: SG_STATUS_COLORS[0],
      breakdown: ['Criminal Division: 52% (22)', 'Civil Division: 48% (20)'],
    },
    { label: 'Reverted', value: 28, color: SG_STATUS_COLORS[1], breakdown: ['Criminal Division: 100% (28)'] },
    { label: 'Escalated', value: 7, color: SG_STATUS_COLORS[2], breakdown: ['Civil Division: 100% (7)'] },
    {
      label: 'Forwarded',
      value: 95,
      color: SG_STATUS_COLORS[3],
      breakdown: ['Criminal Division: 40% (38)', 'Civil Division: 60% (57)'],
    },
    {
      label: 'Completed',
      value: 312,
      color: SG_STATUS_COLORS[4],
      breakdown: ['Criminal Division: 55% (172)', 'Civil Division: 45% (140)'],
    },
  ],
};

export const MOCK_OPERATIONAL_STATUS_CHART: DashboardChartResponse = {
  slices: [
    { label: 'Reverted', value: 28, color: OP_STATUS_COLORS[0] },
    { label: 'Escalated', value: 7, color: OP_STATUS_COLORS[1] },
    { label: 'Forwarded', value: 95, color: OP_STATUS_COLORS[2] },
    { label: 'Completed', value: 312, color: OP_STATUS_COLORS[3] },
  ],
};

export const MOCK_CATEGORY_CHART: DashboardChartResponse = {
  slices: [
    {
      label: 'Civil Div. – Advise',
      value: 142,
      color: CATEGORY_COLORS[0],
      breakdown: ['C – Institution of Actions: 63% (90)', 'C – Action Instituted by State: 37% (52)'],
    },
    { label: 'Civil Div. – Litigation', value: 264, color: CATEGORY_COLORS[1] },
    { label: 'Criminal Div. – Advice', value: 312, color: CATEGORY_COLORS[2] },
    { label: 'Criminal Div. – Litigation', value: 287, color: CATEGORY_COLORS[3] },
    { label: 'Extradition & MLA', value: 78, color: CATEGORY_COLORS[4] },
    { label: 'Civil Lit. – Appellate', value: 54, color: CATEGORY_COLORS[5] },
    { label: 'Criminal Lit. – Appellate', value: 63, color: CATEGORY_COLORS[6] },
    { label: 'RTI', value: 21, color: CATEGORY_COLORS[7] },
    { label: 'Public Petitions', value: 18, color: CATEGORY_COLORS[8] },
    { label: 'Nominations', value: 9, color: CATEGORY_COLORS[9] },
    { label: 'Attorney General', value: 12, color: CATEGORY_COLORS[10] },
    { label: 'AGD Internal', value: 6, color: CATEGORY_COLORS[11] },
  ],
};

/** Operational dashboard uses the same cases but with statuses adjusted for assigned work. */
export function getOperationalMockCases(): DashboardCaseRow[] {
  return MOCK_DASHBOARD_CASES.map((row) => {
    if (row.taskStatus === 'Pending Assignment') {
      return { ...row, taskStatus: 'Forwarded' };
    }
    return row;
  });
}

export function getMockSummary(variant: DashboardVariant): DashboardSummaryResponse {
  return variant === 'sg' ? MOCK_SG_SUMMARY : MOCK_OPERATIONAL_SUMMARY;
}

export function getMockStatusChart(variant: DashboardVariant): DashboardChartResponse {
  return variant === 'sg' ? MOCK_SG_STATUS_CHART : MOCK_OPERATIONAL_STATUS_CHART;
}

export const MOCK_AUDIT_LOGS: Record<string, DashboardAuditLogEntry[]> = {
  'SG-2024-0892': [
    {
      date: '13 Oct 2023',
      time: '09:12 AM',
      name: 'Ms. K. Perera',
      role: 'Counsel',
      isSystem: false,
      action: 'Case Details Updated',
      badgeVariant: 'orange',
    },
    {
      date: '12 Oct 2023',
      time: '12:30 PM',
      name: 'System',
      role: 'Automated Event',
      isSystem: true,
      action: 'Task Forwarded',
      badgeVariant: 'yellow',
    },
    {
      date: '12 Oct 2023',
      time: '10:32 AM',
      name: 'Ms. K. Perera',
      role: 'Counsel',
      isSystem: false,
      action: 'Case Details Reviewed',
      badgeVariant: 'green',
    },
    {
      date: '11 Oct 2023',
      time: '03:45 PM',
      name: 'Mr. R. Fernando',
      role: 'Deputy SG',
      isSystem: false,
      action: 'Case Allocated',
      badgeVariant: 'blue',
    },
    {
      date: '11 Oct 2023',
      time: '09:00 AM',
      name: 'System',
      role: 'Automated Event',
      isSystem: true,
      action: 'Case Received',
      badgeVariant: 'blue',
    },
  ],
  'SG-2024-0891': [
    {
      date: '12 Jun 2026',
      time: '03:00 PM',
      name: 'System',
      role: 'Automated Event',
      isSystem: true,
      action: 'Task Forwarded',
      badgeVariant: 'yellow',
    },
    {
      date: '12 Jun 2026',
      time: '09:00 AM',
      name: 'Mr. K. Silva',
      role: 'Deputy SG',
      isSystem: false,
      action: 'Case Allocated',
      badgeVariant: 'blue',
    },
    {
      date: '11 Jun 2026',
      time: '10:00 AM',
      name: 'System',
      role: 'Automated Event',
      isSystem: true,
      action: 'Case Received',
      badgeVariant: 'blue',
    },
  ],
};
